import { defineMessages } from 'react-intl';

export default defineMessages({
    informationText: {
        id: 'agent.registration.views.Please review the information below to ensure it is accurate',
        defaultMessage: 'Please review the information below to ensure it is accurate.',
    },
    registrationInformation: {
        id: 'agent.registration.views.To edit your registration request, either click “Previous” to navigate to the information you wish to edit, or select a section you wish to edit in the navigation menu to the left. After editing your registration information, click the “Next” button to save your edits and navigate back to this page. Remember that if you leave the session and do not submit your registration request, the information will not be saved.',
        defaultMessage: 'To edit your registration request, either click “Previous” to navigate to the information you wish to edit, or select a section you wish to edit in the navigation menu to the left. After editing your registration information, click the “Next” button to save your edits and navigate back to this page. Remember that if you leave the session and do not submit your registration request, the information will not be saved.',
    },
    submittingInformation: {
        id: 'agent.registration.views.agent.registration.views.By submitting this registration request, you certify that the information on this page is true and correct to the best of your knowledge. Knowingly presenting false or fraudulent information is a violation of Texas state law.',
        defaultMessage: 'By submitting this registration request, you certify that the information on this page is true and correct to the best of your knowledge. Knowingly presenting false or fraudulent information is a violation of Texas state law.',
    },
     //US26499- error messages added
    agencyFailed: {
        id: 'agent.registration.views.There was a problem submitting your request. Please Submit again',
        defaultMessage:
            'There was a problem submitting your request. Please Submit again.',
    },
    errors: {
        id: 'agent.registration.views.Error',
        defaultMessage: 'Error',
    },

});